import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { MobileProvider } from './contexts/MobileContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { ChatProvider } from './contexts/ChatContext'
import { VoiceProvider } from './contexts/VoiceContext'
import ErrorBoundary from './components/ErrorBoundary'
import { Router as AppRouter } from './routes/Router'
import { routes } from './routes/config'
import SignIn from './pages/SignIn'
import { TRPCProvider } from './lib/trpc/hooks'
import { InventoryChat } from './components/chat'

function App() {
  // Check for direct login mode via query parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('directlogin') === 'true') {
    return (
      <ErrorBoundary>
        <SignIn />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <TRPCProvider>
        <ThemeProvider>
          <AuthProvider>
            <MobileProvider>
              <NotificationProvider>
                <ChatProvider>
                  <VoiceProvider>
                    <Router>
                      <AppRouter routes={routes} />
                      <InventoryChat />
                    </Router>
                  </VoiceProvider>
                </ChatProvider>
              </NotificationProvider>
            </MobileProvider>
          </AuthProvider>
        </ThemeProvider>
      </TRPCProvider>
    </ErrorBoundary>
  )
}

export default App
